module.exports = __webpack_public_path__ + "media/components/country-flag/static/ba-cef03145202b5febfacc35716bd367a5.svg";